import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineSmallButton, PrimaryButton,} from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_SMALL_OUTLINE_BUTTONS, FLAT_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatOutlineSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineSmallButton} span={FLAT_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="sm" outline color="primary" id="Tooltip-61" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-61" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-outline-primary btn-sm</ToolTip>
          {FLAT_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} outline={true} size="sm"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatOutlineSmallButtons;
